/**
 * RPA / API switch for Group Inbox configuration fetches.
 *
 * @module groupInboxRouteToggler
 */
import { ToggleSwitch } from "@risalabs_frontend_org/oasis-ui-kit";
import {
  GroupInboxRoute,
  GROUP_INBOX_ROUTES,
} from "../../../../../../shared/api/services/groupInbox/groupInboxConfigTypes";
import {
  GROUP_INBOX_ROUTE_API_LABEL,
  GROUP_INBOX_ROUTE_RPA_LABEL,
} from "../../../../../../shared/constants/stringLiterals";

/** DOM id for the Group Inbox route toggle switch. */
const GROUP_INBOX_ROUTE_TOGGLE_ID = "group-inbox-route";

export interface GroupInboxRouteTogglerProps {
  /** Currently selected Group Inbox config source. */
  selectedRoute: GroupInboxRoute;
  /** Called with `rpa` or `api` when the user flips the switch. */
  onRouteChange: (route: GroupInboxRoute) => void;
}

/**
 * Renders a labeled toggle matching ViewCard: off is RPA, on is API.
 *
 * @param props - Selected route and change handler
 * @returns RPA / API toggle switch
 */
const GroupInboxRouteToggler = ({
  selectedRoute,
  onRouteChange,
}: GroupInboxRouteTogglerProps) => {
  const isApiRoute = selectedRoute === GROUP_INBOX_ROUTES.API;
  const unselectedLabelClass = "text-sm font-semibold text-black";
  const selectedLabelClass = "text-sm font-semibold text-[#0056D6]";

  return (
    <div className="flex shrink-0 items-center gap-2">
      <span className={isApiRoute ? unselectedLabelClass : selectedLabelClass}>
        {GROUP_INBOX_ROUTE_RPA_LABEL}
      </span>
      <div className="mt-[5px]">
        <ToggleSwitch
          key={isApiRoute ? "group-inbox-api" : "group-inbox-rpa"}
          id={GROUP_INBOX_ROUTE_TOGGLE_ID}
          defaultChecked={isApiRoute}
          onChangeEmit={(data) => {
            onRouteChange(
              data.value ? GROUP_INBOX_ROUTES.API : GROUP_INBOX_ROUTES.RPA,
            );
          }}
        />
      </div>
      <span className={isApiRoute ? selectedLabelClass : unselectedLabelClass}>
        {GROUP_INBOX_ROUTE_API_LABEL}
      </span>
    </div>
  );
};

export default GroupInboxRouteToggler;
